import { BaseAPI } from './BaseAPI.js'
import { Form } from '../types/index.js'

export default class FormsAPI extends BaseAPI<Form> {
  override get resource(): string {
    return '/forms'
  }
}
